<template>
  <section class="relative bg-[#ededec] px-6 lg:px-16 xl:px-40 py-16 md:py-24">
    <div class="flex items-start justify-between gap-6 mb-12 md:mb-16">
      <div class="flex items-start gap-2">
        <div class="bg-primary-dark rounded-[2px] w-3 h-3 mt-[13px] shrink-0" />
        <h2 class="font-display font-semibold text-3xl md:text-[56px] leading-tight text-surface-1 !mt-0 !mb-0">
          {{ t('home.caseStudies.title') }}
        </h2>
      </div>
      <RouterLink
        :to="{ name: 'cases' }"
        class="hidden md:inline-flex items-center gap-4 rounded bg-primary hover:bg-primary-dark text-white hover:text-white text-[18px] px-4 py-2.5 transition-colors mt-[14px] shrink-0"
      >
        <span>{{ t('home.caseStudies.cta') }}</span>
        <VaIcon name="menu_book" :size="24" />
      </RouterLink>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <RouterLink
        v-for="cs in cases" :key="cs.key"
        :to="{ name: 'caseDetail', params: { slug: cs.key } }"
        class="bg-white hover:bg-white text-surface-1 hover:text-surface-1 rounded overflow-hidden flex flex-row min-h-[220px] transition-shadow shadow-[0_24px_60px_-20px_rgba(0,0,0,0.18)] hover:shadow-[0_30px_70px_-20px_rgba(0,0,0,0.28)]"
      >
        <div class="relative w-2/5 shrink-0 overflow-hidden">
          <img :src="cs.imgUrl" alt="" aria-hidden="true" class="absolute inset-0 w-full h-full object-cover" />
          <div class="absolute inset-0 pointer-events-none" style="background: linear-gradient(90deg, transparent 0%, rgba(244,243,243,0) 60%, rgba(244,243,243,0.85) 100%);" />
        </div>
        <div class="flex-1 flex flex-col gap-3 p-6">
          <span class="inline-flex items-center self-start px-3 py-1 rounded bg-primary/10 text-primary-dark text-sm font-medium">
            {{ t(`cases.projects.${cs.key}.tag`) }}
          </span>
          <h3 class="font-display font-semibold text-2xl text-surface-1 !mt-0 !mb-0">
            {{ t(`cases.projects.${cs.key}.name`) }}
          </h3>
          <p class="font-sans text-base text-surface-1 !mt-0 !mb-0">
            {{ t(`cases.projects.${cs.key}.body`) }}
          </p>
        </div>
      </RouterLink>
    </div>

    <RouterLink
      :to="{ name: 'cases' }"
      class="md:hidden mt-8 inline-flex items-center gap-4 rounded bg-primary hover:bg-primary-dark text-white hover:text-white text-[18px] px-4 py-2.5 transition-colors"
    >
      <span>{{ t('home.caseStudies.cta') }}</span>
      <VaIcon name="menu_book" :size="24" />
    </RouterLink>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { VaIcon } from 'vuestic-ui'
import { cases } from '@/views/cases/cases'

const { t } = useI18n()
</script>
